// ===============================================================================
// API CONFIGURATION
// ===============================================================================
// Centralized configuration for RTK Query options to prevent unnecessary API calls
// ===============================================================================

/**
 * Default query options to prevent unnecessary refetches
 * These settings ensure API calls are only made when necessary
 */
export const DEFAULT_QUERY_OPTIONS = {
  refetchOnMountOrArgChange: false,
  refetchOnFocus: false,
  refetchOnReconnect: false
} as const;

/**
 * Query options for user-related data that should be cached longer
 */
export const USER_QUERY_OPTIONS = {
  ...DEFAULT_QUERY_OPTIONS,
  // User data changes infrequently, so we can cache it longer
  refetchOnMountOrArgChange: 300 // 5 minutes
} as const;

/**
 * Query options for real-time data that should be refetched more frequently
 */
export const REALTIME_QUERY_OPTIONS = {
  ...DEFAULT_QUERY_OPTIONS,
  refetchOnMountOrArgChange: 30, // 30 seconds
  refetchOnReconnect: false // Disabled to prevent unnecessary API calls
} as const;

/**
 * Query options for static/lookup data that rarely changes
 */
export const STATIC_QUERY_OPTIONS = {
  ...DEFAULT_QUERY_OPTIONS,
  refetchOnMountOrArgChange: 600 // 10 minutes
} as const;

/**
 * Query options for dashboard data that should be cached but refreshed periodically
 */
export const DASHBOARD_QUERY_OPTIONS = {
  ...DEFAULT_QUERY_OPTIONS,
  refetchOnMountOrArgChange: 300 // 5 minutes
} as const;

/**
 * Inbox queries: short remount cache plus refetch when the window regains focus.
 */
export const NOTIFICATION_QUERY_OPTIONS = {
  ...REALTIME_QUERY_OPTIONS,
  refetchOnFocus: true,
  refetchOnReconnect: true
} as const;
